import { OrderedMap } from 'immutable';
import * as ReviewTypes from './ReviewType';
export const RatingAxes = {
  OVERALL: 'OVERALL',
  VALUE: 'VALUE',
  // Apps
  USABILITY: 'USABILITY',
  FUNCTIONALITY: 'FUNCTIONALITY',
  SUPPORT_DOCS: 'SUPPORT_DOCS',
  //Themes
  PERFORMANCE: 'PERFORMANCE',
  // Profiles
  RESULT_QUALITY: 'RESULT_QUALITY',
  CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
  COMMUNICATION: 'COMMUNICATION'
};
export const AppQualityRatingsTemplate = OrderedMap({
  [RatingAxes.USABILITY]: null,
  [RatingAxes.FUNCTIONALITY]: null,
  [RatingAxes.VALUE]: null,
  [RatingAxes.SUPPORT_DOCS]: null
});
export const AppRatingAxes = [RatingAxes.OVERALL, RatingAxes.VALUE, RatingAxes.USABILITY, RatingAxes.FUNCTIONALITY, RatingAxes.SUPPORT_DOCS];
export const ThemeRatingAxes = [RatingAxes.OVERALL, RatingAxes.USABILITY, RatingAxes.PERFORMANCE, RatingAxes.VALUE, RatingAxes.SUPPORT_DOCS];
export const QualityRatingsByReviewType = {
  [ReviewTypes.APP]: AppRatingAxes.slice(1),
  [ReviewTypes.THEME]: ThemeRatingAxes.slice(1)
};